import { transformToHtml } from '../../utils/CommonUtils';
import { footerDomDT, footerIntlDT } from '../../utils/htmlUtil/htmlFooterDT';

export default function FooterCityDT(props) {
  const { footer_data: footer, isIntl } =  props?.data || {};
  let footerData = footer && footer != null ? footer : '';
  if (footerData === '' && isIntl) {
    footerData = footerIntlDT;
  } else if (footerData === '') {
    footerData = footerDomDT;
  }
  return (
    <>
      <div id="footer_block">{ transformToHtml(footerData)}</div>
    </>
  );
}
